import RefreshIcon from "@mui/icons-material/Refresh";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { FilterType } from "../../../configs/filterTypes";
import { Filter, Search } from "../../../configs/productOrder";
import { SortType } from "../../../configs/sortTypes";
import { ColumnDiv } from "../../styled/commonStyles";
import FilterIcon from "../../svg/FilterIcon";
import SearchBar from "../SearchBar";
import SortMenu from "../SortMenu";
import FilterOptions from "./FilterOptions";
import {
    BoxWrapper,
    ButtonContainer,
    ClearFilterButton,
    FilterSortWrapper,
    RefreshButton,
    SearchFilterBarWrapper,
} from "./Styled";

interface FilterSortProps {
    sortTypes: SortType[];
    setIsFilterOptionOpen: Function;
    fetchItems: Function;
    setCurrentPage: Function;
    filterTypes?: FilterType[];
}

export interface ButtonType {
    isViewed: boolean;
    element: React.ReactNode;
}

const FilterSort = ({
    sortTypes,
    setIsFilterOptionOpen,
    fetchItems,
    setCurrentPage,
    filterTypes,
}: FilterSortProps) => {
    const [isClickedFilter, setIsClickedFilter] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    const onClickFilter = () => {
        setIsClickedFilter(!isClickedFilter);
        setIsFilterOptionOpen((prev: boolean) => !prev);
    };

    const handleReset = () => {
        // Clear all URL parameters except tab
        const params = new URLSearchParams();
        const currentTab = new URLSearchParams(location.search).get('tab');
        if (currentTab) {
            params.set('tab', currentTab);
        }
        
        const newURL = `${location.pathname}?${params.toString()}`;
        navigate(newURL, { replace: true });
        
        // Reload the page
        window.location.reload();
    };

    return (
        <FilterSortWrapper>
            {filterTypes && (
                <BoxWrapper
                    data-testid="filter-button"
                    isClicked={isClickedFilter}
                    onClick={onClickFilter}
                >
                    {Filter.filterText}
                    <FilterIcon
                        defaultColor="black"
                        selectedColor="white"
                        isSelected={isClickedFilter}
                    />
                </BoxWrapper>
            )}
            {sortTypes && sortTypes.length > 0 && (
                <SortMenu
                    sortTypes={sortTypes}
                    fetchItems={fetchItems}
                    setCurrentPage={setCurrentPage}
                />
            )}
        </FilterSortWrapper>
    );
};

interface SearchFilterProps {
    sortTypes?: SortType[];
    fetchItems: Function;
    filterTypes?: FilterType[];
    textString?: string;
    setCurrentPage: Function;
    rightButtons?: ButtonType[];
    onRefresh?: () => void;
    onClearFilters?: () => void;
    defaultFilterParams?: Record<string, string>;
}

const SearchFilterBar = ({
    sortTypes,
    fetchItems,
    filterTypes,
    textString,
    setCurrentPage,
    rightButtons,
    onRefresh,
    onClearFilters,
    defaultFilterParams,
}: SearchFilterProps) => {
    const [isFilterOptionsOpen, setIsFilterOptionOpen] = useState(false);

    return (
        <ColumnDiv gap={"0px"}>
            <SearchFilterBarWrapper>
                <ButtonContainer>
                    <SearchBar
                        placeholder={textString ? textString : Search.searchText}
                        fetchItems={fetchItems}
                    />
                    {onRefresh && (
                        <RefreshButton
                            variant="outlined"
                            size="small"
                            startIcon={<RefreshIcon />}
                            onClick={onRefresh}
                        >
                            Đồng bộ
                        </RefreshButton>
                    )}
                    {onClearFilters && (
                        <ClearFilterButton
                            variant="outlined"
                            size="small"
                            onClick={onClearFilters}
                        >
                            Xóa bộ lọc
                        </ClearFilterButton>
                    )}
                </ButtonContainer>
                {(sortTypes || filterTypes) && (
                    <FilterSort
                        sortTypes={sortTypes || []}
                        setIsFilterOptionOpen={setIsFilterOptionOpen}
                        fetchItems={fetchItems}
                        setCurrentPage={setCurrentPage}
                        filterTypes={filterTypes}
                    />
                )}
                {rightButtons && rightButtons.length > 0 && (
                    <>
                        {rightButtons.map((button, index) => (
                            button.isViewed && <React.Fragment key={index}>
                                {button.element}
                            </React.Fragment>
                        ))}
                    </>
                )}
            </SearchFilterBarWrapper>

            {filterTypes && (
                <TransitionGroup>
                    {isFilterOptionsOpen && (
                        <CSSTransition
                            classNames="filter-options"
                            timeout={200}
                            key="aa"
                        >
                            <FilterOptions
                                key="aa"
                                filterTypes={filterTypes}
                                fetchItems={fetchItems}
                                setCurrentPage={setCurrentPage}
                                defaultFilterParams={defaultFilterParams}
                            />
                        </CSSTransition>
                    )}
                </TransitionGroup>
            )}
        </ColumnDiv>
    );
};

export default SearchFilterBar;
